import * as React from 'react';
import cn from 'classnames';
import ContentEditable, { ContentEditableEvent } from 'react-contenteditable';
import { useCallback, useState } from 'react';

import styles from './SimpleTextEditor.modules.scss';

type Props = {
  text: string;
  isEditMode: boolean;
  onChange(text: string): void;
  className?: string;
  onFocus?(): void;
  onBlur?(): void;
};

const SimpleTextEditor: React.FC<Props> = ({
  onChange,
  isEditMode,
  text,
  className,
  onFocus,
  onBlur,
}: Props) => {
  const [focused, setFocused] = useState(false);

  const handleChange = useCallback(
    (e: ContentEditableEvent) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <ContentEditable
      className={cn(
        className,
        focused && styles.focused,
        !focused && text === '' && styles.empty
      )}
      html={text}
      disabled={!isEditMode}
      onChange={handleChange}
      tagName="div"
      onFocus={() => {
        setFocused(true);
        onFocus?.();
      }}
      onBlur={() => {
        setFocused(false);
        onBlur?.();
      }}
    />
  );
};

SimpleTextEditor.defaultProps = {
  isEditMode: false,
};

export default React.memo(SimpleTextEditor);
